import { tOrderStatus } from "tmt_api/src/types/types.validator";

import { kColors } from "src/kColors";
import { tPdBadgeColorScheme } from "src/components/v2/layout";

const DECLINED_ORDER_STATUS: tOrderStatus[] = ["Cancelled", "Declined"];

export const getThemeColorFromOrderStatus = (status: tOrderStatus): string => {
  if (DECLINED_ORDER_STATUS.includes(status)) return kColors.red200;
  if (status === "Pending") return kColors.pink;
  if (status === "Awaiting Fulfillment") return kColors.orange200;
  if (status === "Shipped") return kColors.green200;
  if (status === "Complete") return kColors.yellow200;
  return kColors.gray300;
};

export const getColorSchemeFromOrderStatus = (status: tOrderStatus): tPdBadgeColorScheme => {
  if (DECLINED_ORDER_STATUS.includes(status)) return "red";
  if (status === "Pending") return "pink";
  if (status === "Awaiting Fulfillment") return "orange";
  return "green";
};
